export default "__VITE_ASSET__Cob7ym____"